export default "__VITE_ASSET__R1Akcyks__"